import React from 'react'
import { Box } from '@chatterbug/aaron'

export type Props = {
  sx?: Record<string, unknown>
}

const PageWrapupCard: React.FC<Props> = ({ sx, children }) => {
  return (
    <Box
      bg="white100"
      borderRadius="1x"
      boxShadow="overlay"
      px={{ _: '2x', tablet: '5x' }}
      py={{ _: '3x', tablet: '5x' }}
      {...sx}
    >
      {children}
    </Box>
  )
}

export default PageWrapupCard
